import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-4" data-id="element-235">
      {items.map((item, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md" data-id="element-236">
          <button onClick={() => toggleItem(index)} className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors hover:bg-gray-50" data-id="element-237">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-238">
              {item.question}
            </span>
            <ChevronDown className={`w-5 h-5 text-[#0D9488] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-239" />
          </button>

          <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-240">
            <div className="px-6 pb-5 pt-2 text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-241">
              {item.answer}
            </div>
          </div>
        </div>)}
    </div>;
}